/**
 * @author: dongjing
 * @file: description
 * @Date: 2019-12-09 18:58:38
 * @LastEditors: dongjing
 * @LastEditTime: 2019-12-14 20:47:51
 */
import React from 'react';
import { IconFont } from '@src/features/common';
import { openTargetBlankPage } from '@src/utils';
import './SFCGroupTitle.less';

export interface ISFCGroupTitleProps {
  /** 标题 */
  title: string;
  /** icon类型 */
  iconType: string;
  /** 跳转的url */
  url: string;
}
type Props = ISFCGroupTitleProps;

export function SFCGroupTitle(props: Readonly<Props>) {
  const { title, iconType, url } = props;
  return (
    <div className="common-presenter k-home-group-title">
      <div>
        <IconFont type={iconType} />
        <span>{title}</span>
      </div>
      <IconFont
        type="icon-jiantou"
        onClick={() => {
          openTargetBlankPage(url);
        }}
      />
    </div>
  );
}

export default SFCGroupTitle;
